import sc from 'styled-components';
import {Drawer, Layout, UnifonTheme} from '@phonectas/unifon-ui-kit';

export const StyledDrawerExpander = sc(Layout)<{theme: UnifonTheme}>`
	width: 51px;
	cursor: pointer;
	padding: ${({theme}) => theme.spacing(7, 4)};
	box-sizing: border-box;
    svg {
        opacity: 0.5;
        transition: opacity 200ms;
    }
    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

export const StyledDrawer = sc(Drawer)<{theme: UnifonTheme}>`
	right: -20px !important;
	border-radius: ${({theme}) => theme.borderRadius * 2}px 0 0 0;
`;

